<template>
  <div class="single-post px-2 overflow-x-auto my-20 flex flex-row justify-center">
    <blockquote
      v-if="postLink"
      class="instagram-media"
      data-instgrm-captioned
      :data-instgrm-permalink="embedLink"
      data-instgrm-version="14"
      style="
        background: #fff;
        border: 0;
        border-radius: 3px;
        box-shadow:
          0 0 1px 0 rgba(0, 0, 0, 0.5),
          0 1px 10px 0 rgba(0, 0, 0, 0.15);
        margin: 1px;
        max-width: 540px;
        min-width: 326px;
        padding: 0;
        width: 99.375%;
        width: -webkit-calc(100% - 2px);
        width: calc(100% - 2px);
      "
    >
      <div style="padding: 16px">
        <a
          :href="embedLink"
          style="
            background: #ffffff;
            line-height: 0;
            padding: 0 0;
            text-align: center;
            text-decoration: none;
            width: 100%;
          "
          target="_blank"
        >
          <div style="display: flex; flex-direction: row; align-items: center">
            <div
              style="
                background-color: #f4f4f4;
                border-radius: 50%;
                flex-grow: 0;
                height: 40px;
                margin-right: 14px;
                width: 40px;
              "
            ></div>
            <div style="display: flex; flex-direction: column; flex-grow: 1; justify-content: center">
              <div
                style="
                  background-color: #f4f4f4;
                  border-radius: 4px;
                  flex-grow: 0;
                  height: 14px;
                  margin-bottom: 6px;
                  width: 100px;
                "
              ></div>
              <div style="background-color: #f4f4f4; border-radius: 4px; flex-grow: 0; height: 14px; width: 60px"></div>
            </div>
          </div>
          <div style="padding: 19% 0"></div>
          <div style="display: block; height: 50px; margin: 0 auto 12px; width: 50px">
            <InstagramIcon class="block w-[50px] h-[50px] text-black" />
          </div>
          <div style="padding: 12.5% 0"></div>
          <div style="display: flex; flex-direction: row; margin-bottom: 14px; align-items: center">
            <div>
              <div
                style="
                  background-color: #f4f4f4;
                  border-radius: 50%;
                  height: 12.5px;
                  width: 12.5px;
                  transform: translateX(0px) translateY(7px);
                "
              ></div>
              <div
                style="
                  background-color: #f4f4f4;
                  height: 12.5px;
                  transform: rotate(-45deg) translateX(3px) translateY(1px);
                  width: 12.5px;
                  flex-grow: 0;
                  margin-right: 14px;
                  margin-left: 2px;
                "
              ></div>
              <div
                style="
                  background-color: #f4f4f4;
                  border-radius: 50%;
                  height: 12.5px;
                  width: 12.5px;
                  transform: translateX(9px) translateY(-18px);
                "
              ></div>
            </div>
            <div style="margin-left: 8px">
              <div style="background-color: #f4f4f4; border-radius: 50%; flex-grow: 0; height: 20px; width: 20px"></div>
              <div
                style="
                  width: 0;
                  height: 0;
                  border-top: 2px solid transparent;
                  border-left: 6px solid #f4f4f4;
                  border-bottom: 2px solid transparent;
                  transform: translateX(16px) translateY(-4px) rotate(30deg);
                "
              ></div>
            </div>
            <div style="margin-left: auto">
              <div
                style="
                  width: 0px;
                  border-top: 8px solid #f4f4f4;
                  border-right: 8px solid transparent;
                  transform: translateY(16px);
                "
              ></div>
              <div
                style="background-color: #f4f4f4; flex-grow: 0; height: 12px; width: 16px; transform: translateY(-4px)"
              ></div>
              <div
                style="
                  width: 0;
                  height: 0;
                  border-top: 8px solid #f4f4f4;
                  border-left: 8px solid transparent;
                  transform: translateY(-4px) translateX(8px);
                "
              ></div>
            </div>
          </div>
          <div
            style="display: flex; flex-direction: column; flex-grow: 1; justify-content: center; margin-bottom: 24px"
          >
            <div
              style="
                background-color: #f4f4f4;
                border-radius: 4px;
                flex-grow: 0;
                height: 14px;
                margin-bottom: 6px;
                width: 224px;
              "
            ></div>
            <div
              style="background-color: #f4f4f4; border-radius: 4px; flex-grow: 0; height: 14px; width: 144px"
            ></div></div
        ></a>
      </div>
    </blockquote>
  </div>
</template>

<script>
import InstagramIcon from '@/components/icons/InstagramIcon.vue';

export default defineNuxtComponent({
  name: 'SingleSocialMediaPost - Instagram',
  components: {
    InstagramIcon,
  },
  props: {
    postLink: {
      type: String,
      default: null,
    },
  },
  computed: {
    embedLink() {
      return this.postLink && `${this.postLink}?utm_source=ig_embed&utm_campaign=loading`;
    },
  },
  mounted() {
    this.addInstagramScript();
  },
  methods: {
    addInstagramScript() {
      if (!document.querySelector('[data-post="instagram"]')) {
        const script = document.createElement('script');
        script.setAttribute('src', 'https://www.instagram.com/embed.js');
        script.setAttribute('async', '');
        script.setAttribute('data-post', 'instagram');
        document.head.appendChild(script);
      }
    },
  },
});
</script>

<style>
@reference "~/assets/css/main.css";
@media screen and (min-width: 350px) {
  .single-post {
    @apply container px-0;
  }
}

.instagram-media {
  background: #fff;
  border: 0;
  border-radius: 3px;
  box-shadow:
    0 0 1px 0 rgba(0, 0, 0, 0.5),
    0 1px 10px 0 rgba(0, 0, 0, 0.15);
  margin: 1px;
  max-width: 540px;
  min-width: 326px;
  padding: 0;
  width: 99.375%;
  width: -webkit-calc(100% - 2px);
  width: calc(100% - 2px);
}
</style>
